import React, { FC } from 'react'
import * as pageUtils from './__details.utils'
import { CheckboxList, RadioList } from '@utils/request'
import { formatStrapiText } from '@utils/methods'
import requestForm from '@components/requestForms/request.form'
import { REQUEST_CONFIGS_KEYS } from '@services/constants'

const CollectBulkyItemsFormDetails: FC<pageUtils.Props> = ({
	pageAssets,
	request
}) => {
	const { authUser } = requestForm()

	const getItemFromString = (list, answer?: string): any[] => {
		return list
			.filter((element) => answer?.includes(element.value))
			.map((item) => item)
	}

	const radioListYesNo: RadioList[] = [
		{
			label: pageAssets?.request_form_select_yes,
			value: 'true',
			key: 'request_form_select_yes'
		},
		{
			label: pageAssets?.request_form_select_no,
			value: 'false',
			key: 'request_form_select_no'
		}
	]

		const bulkyItemsCheckboxList: CheckboxList[] = [
			{
				label:
					pageAssets?.request_form_collectBulkyItems_christmasTreeBranches_label,
				extraText:
					pageAssets?.request_form_collectBulkyItems_christmasTreeBranches_description,
				key: 'request_form_commerialPermit_typesOfWorkEnseigne_artisticWallRepresentation',
				value: REQUEST_CONFIGS_KEYS.bulkyItemType.christmasTreeBranches,
				checked: false,
				index: 0
			},
			{
				label: pageAssets?.request_form_collectBulkyItems_matress_label,
				extraText: pageAssets?.request_form_collectBulkyItems_matress_description,
				key: 'request_form_commerialPermit_typesOfWorkEnseigne_newSign',
				value: REQUEST_CONFIGS_KEYS.bulkyItemType.matress,
				checked: false,
				index: 1
			},
			{
				label: pageAssets?.request_form_collectBulkyItems_dryMaterials_label,
				extraText:
					pageAssets?.request_form_collectBulkyItems_dryMaterials_description,
				key: 'request_form_commerialPermit_typesOfWorkEnseigne_replaceSign',
				value: REQUEST_CONFIGS_KEYS.bulkyItemType.dryMaterials,
				checked: false,
				index: 2
			},
			{
				label: pageAssets?.request_form_collectBulkyItems_residues_label,
				extraText:
					pageAssets?.request_form_collectBulkyItems_residues_description,
				key: 'request_form_commerialPermit_typesOfWorkEnseigne_artisticWallRepresentation',
				value: REQUEST_CONFIGS_KEYS.bulkyItemType.residues,
				checked: false,
				index: 3
			}
		]

	return (
		<>
			<h4 className={pageUtils.classes.h4}>
				{pageAssets?.request_form_parkingPermit_address_of_request}
			</h4>

			<p className={pageUtils.classes.paragraph}>
				<b>{pageAssets.request_form_isSameAdresse_label}</b>
				<br />
				<>
					{
						pageAssets[
							radioListYesNo.find(
								(claim) =>
									claim.value ==
									request.incidentForm?.sameAddressAsApplicant?.toString()
							)?.key!
						]
					}
				</>
			</p>
			{request?.incidentForm?.sameAddressAsApplicant?.toString() ===
			radioListYesNo[1].value ? (
				<div>
					<strong>{pageAssets?.request_form_location}</strong>
					<br />
					<p className={pageUtils.classes.paragraph}>
						{typeof request.incidentForm?.buildingAddress === 'string'
							? request.incidentForm?.buildingAddress
							: request.incidentForm?.buildingAddress?.address}
						<br />
						{typeof request.incidentForm?.buildingAddress !== 'string' && request.incidentForm?.buildingAddress?.appartment}
					</p>
				</div>
			) : (
				<>
					<strong>{pageAssets?.label_address}</strong>
					<br />
					{authUser?.profile?.address.address}
					<br />
					{authUser?.profile?.address.city}
					{authUser?.profile?.address.state
						? ` (${authUser?.profile?.address.state}) `
						: ' '}
					{authUser?.profile?.address.postalCode}
					<br />
					{authUser?.profile?.address.apartment
						? `${formatStrapiText(pageAssets?.label_apartment_office)} ${
								authUser?.profile?.address.apartment
						  }`
						: ''}
				</>
			)}

			<p className={pageUtils.classes.paragraph}>
				<b>{pageAssets?.request_form_collectBulkyItems_checkbox_label}</b>
				<br />

				{getItemFromString(
					bulkyItemsCheckboxList,
					request.incidentForm?.bulkyItemsCheckbox
				).map((item, index) => {
					return (
						<div key={`${index}-bulkyItems-answer`}>
							<b key={`${index}-bulkyItems-summary`}>{item.label}</b>
							<br />
							<span>
								{(() => {
									switch (item.value) {
										case REQUEST_CONFIGS_KEYS.bulkyItemType.matress:
											return request.incidentForm?.bulkyItemsFirst
										case REQUEST_CONFIGS_KEYS.bulkyItemType.dryMaterials:
											return request.incidentForm?.bulkyItemsSecond
										case REQUEST_CONFIGS_KEYS.bulkyItemType
											.christmasTreeBranches:
											return request.incidentForm?.bulkyItemsThird
										case REQUEST_CONFIGS_KEYS.bulkyItemType.residues:
											return request.incidentForm?.bulkyItemsFourth
										default:
											return ''
									}
								})()}
							</span>
						</div>
					)
				})}
			</p>
		</>
	)
}

export default CollectBulkyItemsFormDetails
